import React, { useCallback, useEffect } from "react";
import styled from "styled-components";

const SytledWrapper = styled.div`
  width: 100%;

  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: left;
`;

const StyledTitleDiv = styled.div`
  width: 100%;
  margin-top: 0;
  margin-left: 0;
  padding: 0 0 0 0;
  border-radius: 0;

  text-align: center;
`;

const StyledSectionTitle = styled.div`
  width: 100%;
  margin-top: 0;
  margin-left: 0;
  padding: 0 0 0 0;
  border-radius: 0;
  text-align: left;
`;

const StyledSectionDesc = styled.div`
  width: 100%;
  margin-top: 0;
  margin-left: 0;
  padding: 0 0 0 0;
  border-radius: 0;
  text-align: left;
`;

const StyledSectionContent = styled.div`
  width: 100%;
  margin-top: 0;
  margin-left: 0;
  padding: 0 0 0 0;
  background: #ffffff;
  border-radius: 0;

  text-align: left;
`;

const StyledPics = styled.img<{ w: string }>`
  margin-top: 0;
  margin-left: 0;
  padding: 0 0 0 0;
  border-radius: 0;

  width: ${({ w }) => w};
`;

export interface BKNoticeBoardPageProps {}

export const BKNoticeBoardPage: React.FC<BKNoticeBoardPageProps> = ({}) => {
  const changeTitle = useCallback((newTitle: string) => {
    if (document.title !== newTitle) {
      document.title = newTitle;
    }
  }, []);

  useEffect(() => {
    changeTitle("公告栏-宝库群组");
  }, []);

  return <SytledWrapper></SytledWrapper>;
};
